import * as React from 'react';
import styles from '../../styles/flyouts/stages/Properties.scss';
import * as _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { __, validateForm, getURLParam } from '../../core/utils';
import { setNotification } from '../../redux/actions/general/notification';
import classNames from 'classnames';
import EditStageForm from '../../forms/stages/EditStageForm';
import {
  listProjectStages,
  readStage,
  updateStage,
} from '../../redux/actions/table/stages';
import { listActiveModules } from '../../redux/actions/general/active_modules';

const Properties = ({
  data,
  collapsed,
  is_project_administrator,
  readAction,
  match,
}) => {
  const handleSubmit = (formData) => {
    formData = {
      ...formData,

      date: {
        ...data?.date,
        ...formData?.date,
      },
    };

    return validateForm(
      updateStage(formData.id, _.omit(formData, ['id'])).then(() => {
        listProjectStages(match.params.project);

        readAction(data.id);

        listActiveModules();

        setNotification(__('project.stages.notification.saved'));
      })
    );
  };

  return (
    <div className={classNames(styles.wrapper, collapsed && styles.collapsed)}>
      <EditStageForm
        isProjectAdministrator={is_project_administrator}
        onSubmit={handleSubmit}
        initialValues={{
          ..._.pick(data, [
            'id',
            'name',
            'description',
            'status',
            'stage_template_id',
            'finished_at',
          ]),
          date: {
            start: data?.date?.start,
            end: data?.date?.end,
            allDay: data?.date?.allDay,
            duration: data?.date?.duration,
            deadline: data?.date?.deadline,
            deadline_date: data?.date?.deadline_date,
          },
          default_visibility: String(data?.default_visibility ?? '1'),
          time_log: {
            planned_time: data?.time_log?.planned_time,
          },
        }}
        projectLanguages={data?.languages}
      />
    </div>
  );
};

export default withRouter(Properties);
